import styled from "styled-components";

export const Container = styled.div`
    background: #fff;
    margin: 24px;
    padding: 24px 32px;
    display: flex;
`;
